import React from 'react';
import { NotificationBanner } from '@ntuctech/tangram-web';
import { useRouter } from 'next/router';
import styled from 'styled-components';

const CustomComponentSc = styled.div`
  box-sizing: border-box;
  width: 45.75rem;
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 9rem;

  @media (max-width: 767px) {
    width: 20.5rem;
  }
`;

const CustomContainer = ({ children }) => {
  return <CustomComponentSc>{children}</CustomComponentSc>;
};

const FloatingBanner = () => {
  const router = useRouter();

  const { push } = NotificationBanner.useFloatingNotification();
  const pushBanner = () => {
    push({
      variant: 'warning',
      title: 'Sorry! Something went wrong',
      description: 'We can’t establish a connection to the server. Please try again.',
      onClose: () => {
        router.replace('/');
      },
    });
  };

  React.useEffect(() => {
    pushBanner();
  }, []);
};

const MyinfoFloatingError = () => {
  return (
    <NotificationBanner.FloatingBannerContainer container={CustomContainer}>
      <FloatingBanner />
    </NotificationBanner.FloatingBannerContainer>
  );
};

export default MyinfoFloatingError;
